import '../../../common/dashboard/filters/unapplied/toggleable_unapplied_filter_view.js.coffee'
import '../../../common/dashboard/filters/subtype_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedSubTypeFilterView extends Common.Dashboard.Filters.ToggleableUnappliedFilterView
  initialize: ({filter, subtypes}) ->
    super({filter})
    _.extend(@, Common.Dashboard.Filters.SubtypeFilterMixin)
    @subtypes = subtypes

  toggleOpenFilter: ->
    @openSubtypeFilterModal()

  modalTitle: ->
    I18n.t 'common.session.filters.subtype.modal.title'

  modalSubtitle: ->
    I18n.t 'common.session.filters.subtype.modal.subtitle'
